<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="quick-sensorgroup-modal" *ngIf="isReadySensorGroups; else loading">
<!-- <div class="modal-content quick-sensorgroup-modal" *ngIf="isReadySensorGroups; else loading"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Create or Update Sensor Group</h5>
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
    </button>
  </div>

  <div class="modal-body" style="padding: 10px;">
    <div class="container-fluid">

      <div class="form-group" style="margin-bottom: 20px;">
        <label style="font-weight: 500; font-size: 15px;" for="name">Name</label>
        <div class="css-tooltip" [attr.tooltip-data]="sensorGroupNameTooltip">
          <input type="text"  id="name" list="sensorgroupNames" class="form-control" [(ngModel)]="sensorGroup.name"
                [style.color]="!duplicateName ? 'black' : 'red' " style="height: 38px; border-color: lightgray; color: black;"
                (ngModelChange)="updateDisplaySensorGroupInfo(sensorGroup.name)" required autocomplete="off" />
        </div>
        <!-- <datalist id="sensorgroupNames">
            <option [value]="group.name" *ngFor="let group of sensorgroups">{{ group.name }}</option>
        </datalist> -->
      </div>

      <div class="form-group" style="margin-bottom: 20px;">
        <label for="description" style="font-weight: 500; font-size: 15px;">Description</label>
        <input [(ngModel)]="sensorGroup.description" class="form-control" id="description" name="description" required type="text" />
      </div>

      <label for="sensorGroupName" style="font-weight: 500; font-size: 15px; ">Sensors</label>

      <div style="margin-bottom: 20px;">
        <p-table #uuidTable [columns]="sensorGroupUUIDCols" [scrollable]="true" [value]="sensorsDisplayed" scrollHeight="20em">
          <!-- <ng-template pTemplate="caption">
            <label for="sensorGroupName" style="font-size: 17px; margin-left: -10px;">Sensors</label>
          </ng-template> -->

          <ng-template let-columns pTemplate="header">
            <tr style="height: 40px;">
              <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedSensorsDisplayed()" style="padding-left: 2px; font-size: 20px;">▣</div>
                {{col.header}}
              </th>
            </tr>
          </ng-template>

          <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
            <tr style="height: 40px;">
              <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                <p-checkbox
                  [(ngModel)]="rowData.checked" binary="true" id="{{rowData.uuid}}" name="{{rowData.uuid}}"
                  [ngModelOptions]="{standalone: true}"
                  (onChange)="sensorSelectionChanged(rowData)">
                </p-checkbox>
              </td>

              <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                {{ rowData.name }}
              </td>

              <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                {{ rowData.uuid }}
              </td>

              <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                {{ rowData.type }}
              </td>

            </tr>
          </ng-template>
        </p-table>
      </div>

      <div *ngIf="sensorGroup.userFeatureAccess['EditSensorGroup']">
        <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        <button (click)="createOrUpdateSensorGroup()" class="btn btn-success col-xs-5 pull-right" type="button" style="margin-bottom: 15px;">{{ modalMode }}</button>
        <button (click)="bsModalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 10px;" type="button">Cancel</button>
      </div>

    </div>
  </div>
</div>


<ng-template #loading>
  <div class="col-xs-4 col-lg-3" style="margin-top: 20px; margin-left: 20px; margin-bottom: 20px;">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      <span>Loading...</span>
  </div>
</ng-template>


